import React from 'react'
import { connect } from 'react-redux';
import Editor from '../admin/editor/Editor'
import {startInlineEdit} from '../reducers/admin'

const Text = ({tag, entity, block, field, fieldName, value, style, plain, isEditor, edit, startInlineEdit, type, path, refreshTag}) => {
	//if((!block || !block[field.name]) && !entity[field.name]) return null

	//let value = block?block[field.name]:entity[field.name]
	if(!value || value.trim()==='' || value==='<p></p>') return null
	//console.log(isEditor)
	//const Tag = tag || (field && field.tag) || (plain?'span':'div')
	const Tag = tag || (field && field.tag) || 'div'
	const name = fieldName || (field && field.name)
	if(!name) return null
	//console.log(name)
	//console.log(value)
	let props = {}
	//console.log(startInlineEdit)
	if(isEditor) {
		props = {
			onClick: startInlineEdit,
			'data-id': entity._id['$oid'],
			'data-entity-type': entity.type,
			'data-type': type,
			'data-field': name,
			'data-path': path,
			'data-refresh-tag': refreshTag
		}
		if(block) props['data-uuid'] = block.uuid
	}
	return (
		(edit && edit.path===path && edit.id===entity._id['$oid'] && (!block || block.uuid===edit.uuid))
			?<Editor args={edit} text={value} plain={plain} style={style}/>
			:<Tag className={`field-${name}`} 
				dangerouslySetInnerHTML={{__html: value}}
				style={style}
				{...props}
				/>
	)
}

export default connect(state => ({
	edit: state.admin.edit,
	isEditor: state.auth.isEditor
}), dispatch => ({
	startInlineEdit: e => dispatch(startInlineEdit({
			id: e.currentTarget.getAttribute('data-id'),
			entityType: e.currentTarget.getAttribute('data-entity-type'),
			type: e.currentTarget.getAttribute('data-type'),
			uuid: e.currentTarget.getAttribute('data-uuid'),
			field: e.currentTarget.getAttribute('data-field'),
			path: e.currentTarget.getAttribute('data-path'),
			tag: e.currentTarget.getAttribute('data-refresh-tag') 
	}))
}))(Text)


// WEBPACK FOOTER //
// ./src/fm/field/Text.js